import http from "@/http-common";

class MigrationAttendanceService {
    migrate({idSchool, fromDate, toDate}) {
        const body = {
            idSchool: idSchool,
            fromDate: fromDate,
            toDate: toDate,
        };
        return http.post("/migration/attendance/migrate", body);
    }
}

export default new MigrationAttendanceService();
